import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FinanceConfigDialog({ client, onClose, onSaved }) {
  const [form, setForm] = useState({
    is_paying: client.is_paying,
    monthly_fee: client.monthly_fee,
    monthly_backlinks_fee: client.monthly_backlinks_fee,
    monthly_consultant_fee: client.monthly_consultant_fee,
    notes: client.notes,
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/finance/clients-config/${client.client_id}`, form);
      toast.success("Configuration enregistrée");
      onSaved();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally { setSaving(false); }
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-md" data-testid="finance-config-dialog">
        <DialogHeader>
          <DialogTitle>Configuration finance — {client.name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="flex items-center justify-between bg-neutral-50 p-3 rounded">
            <Label htmlFor="paying" className="cursor-pointer">Client payant</Label>
            <Switch id="paying" checked={form.is_paying} onCheckedChange={(v) => set('is_paying', v)} data-testid="cfg-is-paying" />
          </div>
          <FieldEuro label="Forfait mensuel SEO/SEA récurrent" value={form.monthly_fee} onChange={(v) => set('monthly_fee', v)} testid="cfg-monthly-fee" />
          <FieldEuro label="Forfait mensuel backlinks (récurrent)" value={form.monthly_backlinks_fee} onChange={(v) => set('monthly_backlinks_fee', v)} testid="cfg-backlinks-fee" />
          <FieldEuro label="Coût consultant mensuel (interne)" value={form.monthly_consultant_fee} onChange={(v) => set('monthly_consultant_fee', v)} testid="cfg-consultant-fee" />
          <div>
            <Label htmlFor="notes" className="text-xs text-neutral-500">Notes internes</Label>
            <textarea id="notes" rows={2} value={form.notes} onChange={(e) => set('notes', e.target.value)}
              className="w-full mt-1 px-3 py-2 border border-neutral-200 rounded text-sm" data-testid="cfg-notes" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annuler</Button>
          <Button onClick={save} disabled={saving} data-testid="cfg-save">{saving ? 'Enregistrement…' : 'Enregistrer'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

const FieldEuro = ({ label, value, onChange, testid }) => (
  <div>
    <Label className="text-xs text-neutral-500">{label}</Label>
    <div className="relative mt-1">
      <Input type="number" min="0" step="10" value={value} onChange={(e) => onChange(parseFloat(e.target.value) || 0)} className="pr-8" data-testid={testid} />
      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400 text-sm">€</span>
    </div>
  </div>
);
